import { render, staticRenderFns } from "./AccaBonus.vue?vue&type=template&id=05dc6b8c"
import script from "./AccaBonus.vue?vue&type=script&lang=js"
export * from "./AccaBonus.vue?vue&type=script&lang=js"
import style0 from "./AccaBonus.vue?vue&type=style&index=0&id=05dc6b8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports